import React from 'react';
import classnames from 'classnames';
import Tooltip from 'shared/components/Tooltip';
import Label from 'shared/components/Label';
import RadioComponent from 'shared/components/RadioComponent';

const RadioDualComponent = (props) => {
  const {
    name,
    valueA,
    valueB,
    labelA,
    labelB,
    onChange,
    parameters,
    groupName,
    errorMessage,
    className,
    required,
    label,
    labelClassName,
    tooltip,
    children,
    disabled,
  } = props;

  const value = parameters[name];

  return (
    <div className={classnames('form-group row', className)}>
      <div className="col-12 col-md-6">
        <Label label={label} required={required} className={labelClassName}>
          <Tooltip id={`tooltip-${name}`} title={tooltip} />
        </Label>
      </div>
      <div className="col-12 col-md-6">
        {' '}
        <RadioComponent
          inputId={`${groupName}-${name}-${valueA}`}
          name={name}
          label={labelA}
          value={valueA}
          checked={value === valueA}
          onChange={onChange}
          groupName={groupName}
          disabled={disabled}
          inline />
        {' '}
        <RadioComponent
          inputId={`${groupName}-${name}-${valueB}`}
          name={name}
          label={labelB}
          value={valueB}
          checked={value === valueB}
          onChange={onChange}
          groupName={groupName}
          disabled={disabled}
          inline />
      </div>
      <div className="error">
        {errorMessage}
      </div>
      <div>{children}</div>
    </div>
  );
};

RadioDualComponent.defaultProps = {
  labelA: Spree.translations.yes_word,
  labelB: Spree.translations.no_word,
  valueA: '1',
  valueB: '0',
};

export default RadioDualComponent;
